import { featureFlags } from '@seen/core/featureFlags'
import {
  cn,
  HoverCardContent as UIHoverCardContent,
  type HoverCardContentProps as UIHoverCardContentProps,
} from '@seen/ui'
import { type ElementRef, forwardRef } from 'react'
import { useFeatureFlag } from '#src/hooks/useFeatureFlag.ts'

export type HoverCardContentProps = UIHoverCardContentProps

// Same primitive as @seen/ui's, with the explicit zinc border this package's
// surfaces have always used. Sizing, placement, and collision behavior all
// live in the @seen/ui component so both copies stay in step.
//
// This wrapper is also where the viewport-layout flag is resolved: @seen/ui
// cannot read feature flags, so it takes the answer as a prop. Callers can still
// override it explicitly, which is how Storybook renders both states.
export const HoverCardContent = forwardRef<
  ElementRef<typeof UIHoverCardContent>,
  HoverCardContentProps
>(({ className, ...props }, ref) => {
  const viewportLayout = useFeatureFlag(featureFlags.hoverCardViewportLayout)

  return (
    <UIHoverCardContent
      ref={ref}
      viewportLayout={viewportLayout}
      className={cn('border-zinc-200 dark:border-zinc-800', className)}
      {...props}
    />
  )
})
HoverCardContent.displayName = 'HoverCardContent'
